import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../constants/styleConstants';
import SocialLinks from '../SocialLinks';

const useStyles = makeStyles(() => ({
  socialShare: {
    display: 'flex',
    alignItems: 'center',
  },
  socialShareText: {
    fontSize: '13px',
    color: colors.subTitle,
    marginRight: 5,
  },
}));

const SocialShareBlock = ({ socialLinks, className }) => {
  const classes = useStyles();

  return (
    <div className={classes.socialShare}>
      <SocialLinks socialLinks={socialLinks} iconClass={className} />
    </div>
  );
};

SocialShareBlock.propTypes = {
  socialLinks: PropTypes.array.isRequired,
  className: PropTypes.string,
};

SocialShareBlock.defaultProps = {
  className: '',
};

export default SocialShareBlock;
